import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '../views/HomeView.vue'
//import EducationView from '../views/EducationView.vue'
//import SkillsView from '../views/SkillsView.vue'
import GalleryView from '../views/GalleryView.vue'
import ContactView from '../views/ContactView.vue'
//import ComingSoonView from '../views/ComingSoonView.vue'

import AnimationView from '../views/AnimationView.vue'
import GamesView from '../views/GamesView.vue'
import ARView from '../views/ARView.vue'
import VideoPhotoView from '../views/VideoPhotoView.vue'
import EmbeddedView from '../views/EmbeddedView.vue'
import WebDevView from '../views/WebDevView.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView,
    meta: {
      title: 'Portfolio',
    },
  },
  {
    path: '/about',
    name: 'about',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue'),
    meta: {
      title: 'About',
    },
  },
  //{
  //  path: '/education',
  //  name: 'education',
  //  component: EducationView
  //},
  //{
  //  path: '/skills',
  //  name: 'skills',
  //  component: SkillsView
  //},
  {
    path: '/gallery',
    name: 'gallery',
    component: GalleryView,
    meta: {
      title: 'Gallery',
    },
  },
  {
    path: '/contact',
    name: 'contact',
    component: ContactView,
    meta: {
      title: 'Contact',
    },
  },
  //{
  //  path: '/coming-soon',
  //  name: 'coming soon',
  //  component: ComingSoonView
  //},
  {
    path: '/animation',
    name: 'animation',
    component: AnimationView,
    meta: {
      title: 'Animation',
    },
  },
  {
    path: '/games',
    name: 'video games',
    component: GamesView,
    meta: {
      title: 'Video Games',
    },
  },
  {
    path: '/ar',
    name: 'augmented reality',
    component: ARView,
    meta: {
      title: 'AR',
    },
  },
  {
    path: '/video-photo',
    name: 'Video/photo Editing',
    component: VideoPhotoView,
    meta: {
      title: 'Video & Photo Editing',
    },
  },
  {
    path: '/embedded',
    name: 'embedded',
    component: EmbeddedView,
    meta: {
      title: 'Embedded',
    },
  },
  {
    path: '/web-dev',
    name: 'web dev',
    component: WebDevView,
    meta: {
      title: 'Web Dev',
    },
  },
  {
    path: '*',
    redirect: '/'
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  if(to.meta.title) document.title = "Aleks Ray /\\ " + to.meta.title;
  else document.title = "Aleks Ray | Portfolio";
  next();
});

router.afterEach(() => {
  // Scroll to the top of the webpage
  //setTimeout(function() {
  //  $('html, body').scrollTop(0);
  //}, 500);
  
  setTimeout(function() {
    window.scrollTo(0,0);
  }, 500);
})

export default router
